import gsap from 'gsap';

const open = gsap.timeline({
    paused: true,
    onStart: function() {
        $('.header__toggle').addClass('active');
        $('html').addClass('no-scroll');
    },
});

open.to('.collapse', {
	duration: 0.2,
	opacity: 1,
	height: '100dvh',
    y: 0,
	ease: 'linear',
})

open.from('.collapse .header__menu > li ', {
	duration: 0.2,
	opacity: 0,
	y: 20,
	stagger: 0.1,
	ease: 'linear',
});

const close = gsap.timeline({
    paused: true,
    onStart: function() {
        $('.header__toggle').removeClass('active');
        $('html').removeClass('no-scroll');
    },
});

close.to('.collapse', {
	duration: 0.2,
	opacity: 0,
	height: '0',
    y: '-100%',
	ease: 'linear',
})

const timelineToggle = (timeline) => {
    if( timeline.progress() < 1 ) {
        timeline.play();
    } else {
        timeline.restart();
    }
}

$('.header__toggle').on('click', function() {
    if( $(this).hasClass('active')) {
        timelineToggle(close);
    } else {
        timelineToggle(open);
    }
});

$(window).on('resize', function() {
    if( $(window).width() >= 1400 ) {
        timelineToggle(close);
    }
});
